import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import {
    AbstractFormGroupComponent,
    AbstractNgModelComponent,
    ProcessComponent,
    ProcessDetailComponent,
    ProcessListComponent,
    SafePipe
} from '.';
import { EfaactMaterialModule } from '../efaact-material/efaact-material.module';
import { UnsavedChangesService } from '../shared/modal-dialog';
import {
    CategoryComponent,
    CategoryDetailComponent,
    CategoryListComponent
} from './category';
import { ColumnSearchComponent } from './column-search/column-search.component';
import { ColumnFilterHelpDirective } from './directives/column-filter-help/column-filter-help.directive';
import { LetDirective } from './directives/let/ef-let';
import { EfCheckboxComponent } from './ef-checkbox/ef-checkbox.component';
import { EfDropdownComponent } from './ef-dropdown/ef-dropdown.component';
import { EfaactPrimeNGModule } from './efaact-primeng.module';
import { ErrorsSidenavComponent } from './errors-sidenav';
import { ErrorsSidenavModule } from './errors-sidenav/errors-sidenav.module';
import { FeatureFlagDirective } from './feature-flag/feature-flag';
import { FeatureFlagConfig } from './feature-flag/feature-flag-config';
import { LoadingContainerComponent } from './loading/loading-container/loading-container.component';
import { LoadingComponent } from './loading/presenters/loading.component';
import { ConfirmComponent } from './modal-dialog/confirm/confirm.component';
import { UnsavedChangesComponent } from './modal-dialog/confirm/unsaved-changes.component';
import { DialogComponent } from './modal-dialog/dialog.component';
import { FilterHelpDialogComponent } from './modal-dialog/filter-help/filter-help-dialog.component';
import { DialogService } from './modal-dialog/dialog.service';
import { PTableEditorDirective } from './p-datatable-editor.directive';
import { StatusIconComponent } from './status-icon';
import { StatusIconModule } from './status-icon/status-icon.module';
import { StopClickPropagationDirective } from './StopClickPropagation';
import { FilterByPipe } from './util/filter-by.pipe';
import { IsArrayPipe } from './util/is-array';
import { ItemLookupPipe } from './util/ItemLookup';
import { OrderByPipe } from './util/order-by.pipe';
import { BizProcessMenuComponent } from './bizprocess-menu/bizprocess-menu.component';

@NgModule({
    imports: [
        CommonModule,
        EfaactMaterialModule,
        EfaactPrimeNGModule,
        FormsModule,
        ReactiveFormsModule,
        ErrorsSidenavModule,
        UIRouterModule,
        StatusIconModule
    ],
    providers: [DialogService, UnsavedChangesService, FeatureFlagConfig],
    declarations: [
        BizProcessMenuComponent,
        ConfirmComponent,
        DialogComponent,
        UnsavedChangesComponent,
        FilterHelpDialogComponent,
        LoadingContainerComponent,
        LoadingComponent,
        AbstractNgModelComponent,
        AbstractFormGroupComponent,
        ProcessListComponent,
        ProcessDetailComponent,
        ProcessComponent,
        CategoryComponent,
        CategoryListComponent,
        CategoryDetailComponent,
        PTableEditorDirective,
        StopClickPropagationDirective,
        FeatureFlagDirective,
        ItemLookupPipe,
        OrderByPipe,
        FilterByPipe,
        IsArrayPipe,
        SafePipe,
        LetDirective,
        ColumnSearchComponent,
        ColumnFilterHelpDirective,
        EfDropdownComponent,
        EfCheckboxComponent
    ],
    exports: [
        BizProcessMenuComponent,
        OrderByPipe,
        FilterByPipe,
        IsArrayPipe,
        SafePipe,
        ConfirmComponent,
        ItemLookupPipe,
        EfaactMaterialModule,
        EfaactPrimeNGModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PTableEditorDirective,
        StopClickPropagationDirective,
        LoadingContainerComponent,
        LoadingComponent,
        ColumnFilterHelpDirective,
        FeatureFlagDirective,
        ProcessListComponent,
        ProcessDetailComponent,
        ProcessComponent,
        CategoryComponent,
        CategoryListComponent,
        CategoryDetailComponent,
        ErrorsSidenavComponent,
        StatusIconComponent,
        LetDirective,
        ColumnSearchComponent,
        EfDropdownComponent,
        EfCheckboxComponent
    ]
})
export class SharedModule {}
